<script>

    import Title from "./title.svelte";
    import failedImage1 from "../../public/images/failed-images/failed-image-1.svg";
    import failedImage2 from "../../public/images/failed-images/failed-image-2.svg";
    import failedImage3 from "../../public/images/failed-images/failed-image-3.svg";
    import failedImage4 from "../../public/images/failed-images/failed-image-4.svg";
    import { onMount, afterUpdate } from 'svelte';

    const failedImages = [failedImage1, failedImage2, failedImage3, failedImage4]
    const numberOfAnnotationsPerImage = 1

    function assignAnnotations() {
        document.getElementById('annotation-1').onmouseover = () => changeSelectedAnnotation((selectedImage-1)*numberOfAnnotationsPerImage + 1)
        document.getElementById('annotation-1').onmouseout = () => changeAnnotationDisplay()
    }

    let selectedImage = 1;
    let selectedPoint = 0;
    let annotationDisplay = false

    onMount(() => {
        assignAnnotations()
    })

    afterUpdate(() => {
        assignAnnotations()
    })

    const noAnnotationMessage = "Select region for more information."

    const annotations = [
        "Blurriness at edges of dynamic elements (Nerfies).",
        "'Ghosting' artifacts from transient occluders - can only handle static images",
        "Black tire tracks visible through opaque object due to missing viewpoints.",
        "Artefacts close to camera / at edges are commonly caused by neural network approximations.",
    ]

    function changeSelectedAnnotation(i) {
        annotationDisplay = true
        selectedPoint = i-1
        hidefailedImage()
        setTimeout(() => {
            tapBackgroundToHideAnnotation()
        }, 500)
    }

    function changeSelectedImage(i) {
        selectedImage = i
    }

    function changeAnnotationDisplay() {
        annotationDisplay = false
        showfailedImage()
        dontTapBackgroundToHideAnnotation()
    }

    function tapBackgroundToHideAnnotation() {
        document.getElementById('failed-image-svg-container').onclick = () => changeAnnotationDisplay()
    }

    function dontTapBackgroundToHideAnnotation() {
        document.getElementById('failed-image-svg-container').onclick = () => {}
    }

    function hidefailedImage() {
        document.getElementById('failed-image').classList.add("hide")

        // let selectedPointForSwitch = selectedPoint % 1

        // switch (selectedPointForSwitch) {
        //     case 0:
        //         document.getElementById('mask-2').classList.add("remove")
        //         document.getElementById('mask-3').classList.add("remove")
        //         document.getElementById('annotation-2').classList.add("remove")
        //         document.getElementById('annotation-3').classList.add("remove")
        //         break;
        // }
    }

    function showfailedImage() {
        // show main background image
        document.getElementById('failed-image').classList.remove("hide")

        // show annotations
        document.getElementById('annotation-1').classList.remove("remove")

        // show masks
        document.getElementById('mask-1').classList.remove("remove")
    }

</script>

<style>

    #wrapper {
        grid-column: text;
    }

    #thumbnail-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 0.5em;
        /* height: 148px; */
    }

    .thumbnail {
        width: 100%;
        opacity: 0.4;
        /* border: 1px solid var(--gray-bg); */
    }

    .thumbnail-selected {
        /* border-color: black; */
        opacity: 0.8;
    }

    .thumbnail:hover {
        opacity: 1.0;
        cursor: pointer;
    }

    #grid-wrapper {
        display: grid;
        grid-template-columns: 7fr 4fr;
        grid-column-gap: 0.5rem;
    }

    #side-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    /* .ref {
		font-size: 0.8em;
		line-height: 1.5em;
        color: var(--gray);
        padding-bottom: 5px;
    } */

    #caption-wrapper {
        display: flex;
        /* flex-direction: column; */
        /* justify-content: center; */
        align-items: center;
    }

    .caption {
        /* border-left: 1px solid var(--gray-border); */
        padding: 5px 10px;
        /* border-radius: var(--border-radius); */
        /* font-size: 0.85rem; */
        color: var(--gray)
    }

    /* :global(#background) {
        fill-opacity:0
    } */

    :global(#annotation-1, #annotation-2, #annotation-3) {
        cursor: crosshair
    }

    /* :global(#failed-image) {
        opacity: 0.8;
    } */

    :global(.hide) {
        opacity: 0.5;
    }

    :global(.remove) {
        opacity: 0;
    }

    @media(max-width: 768px) {

        #grid-wrapper {
            grid-template-columns: 1fr;
        }

        #thumbnail-wrapper {
            grid-template-columns: repeat(4, 1fr);
        }

        .caption {
            padding-left: 0;
        }

        #wrapper {
          grid-column: screen !important;
        }

    }

    @media(max-width: 1000px) {
        #wrapper {
            grid-column: page;
        }
    }

</style>

<figure class="subgrid">
    <div id="wrapper" class="interactive-container">
        <Title
            titleText="Where can NERF go wrong?"
            subtitleText="Despite the fantastic results, NERF is not a cure-all. It fails in very predictable ways."
        />

        <div id="grid-wrapper">
            <div>
                <div id="failed-image-svg-container">
                    {@html failedImages[selectedImage-1]}
                </div>
            </div>
            <div id="side-wrapper">
                <div id="caption-wrapper">
                    <div class="caption">{annotationDisplay ? annotations[selectedPoint] : noAnnotationMessage}</div>
                </div>
                <div>
                    <div id="thumbnail-wrapper">
                        <div on:click={() => changeSelectedImage(1)}><img class={selectedImage === 1 ? "thumbnail-selected thumbnail" : "thumbnail"} src="images/failed-images/failed-image-1.jpg" alt="" /></div>
                        <div on:click={() => changeSelectedImage(2)}><img class={selectedImage === 2 ? "thumbnail-selected thumbnail" : "thumbnail"} src="images/failed-images/failed-image-2.jpg" alt="" /></div>
                        <div on:click={() => changeSelectedImage(3)}><img class={selectedImage === 3 ? "thumbnail-selected thumbnail" : "thumbnail"} src="images/failed-images/failed-image-3.jpg" alt="" /></div>
                        <div on:click={() => changeSelectedImage(4)}><img class={selectedImage === 4 ? "thumbnail-selected thumbnail" : "thumbnail"} src="images/failed-images/failed-image-4.jpg" alt="" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <figcaption style="grid-column: text;">: Choose between 1 of 4 machine-generated images and brush over the circle callouts to display a short message about each region. Generated images from <d-cite key="mildenhall2020nerf,pumarola2021d,martin2021nerf"></d-cite>.</figcaption>
</figure>
